// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-btn {
  padding: 0.6em 1em; /* پدینگ نسبی */
  border: none;
  border-radius: 8px;
  background-color: #01753C;
  color: white;
  box-shadow: 0 0.1em 1.5em -0.5em #01753C;
  cursor: pointer;
  font-size: 1rem; /* فونت نسبی */
  transition: all 0.3s ease;
}

/* هاور */
.export-btn:hover:not(:disabled) {
  background-color: #025a2e;
  box-shadow: 0 0.2em 2em -0.5em #01753C;
}

/* حالت غیر فعال */
.export-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* رسپانسیو برای موبایل */
/* @media (max-width: 480px) {
  .export-btn {
    padding: 0.5em 0.8em;
    font-size: 0.9rem;
  }
} */



@media (max-width:820px) {

  .export-btn {
    padding: 0.3em 0.8em;
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/ExportExcelButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAE,eAAe;EACnC,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,eAAe,EAAE,cAAc;EAC/B,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;;;;GAKG;;;;AAIH;;EAEE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":[".export-btn {\n  padding: 0.6em 1em; /* پدینگ نسبی */\n  border: none;\n  border-radius: 8px;\n  background-color: #01753C;\n  color: white;\n  box-shadow: 0 0.1em 1.5em -0.5em #01753C;\n  cursor: pointer;\n  font-size: 1rem; /* فونت نسبی */\n  transition: all 0.3s ease;\n}\n\n/* هاور */\n.export-btn:hover:not(:disabled) {\n  background-color: #025a2e;\n  box-shadow: 0 0.2em 2em -0.5em #01753C;\n}\n\n/* حالت غیر فعال */\n.export-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* رسپانسیو برای موبایل */\n/* @media (max-width: 480px) {\n  .export-btn {\n    padding: 0.5em 0.8em;\n    font-size: 0.9rem;\n  }\n} */\n\n\n\n@media (max-width:820px) {\n\n  .export-btn {\n    padding: 0.3em 0.8em;\n    font-size: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
